import { DialogWrapper } from '../../../../shared/components/common/dialogWrapper';
import { FsButton } from '../../../../shared/components/button';
import { Box } from '@mui/material';
import { TextWrapper } from '../../../../shared/components/formUtilities/useTextWrapper';
import { AppRoutes } from '../../../../constants/appRoutes';
import { useTranslation } from 'react-i18next';
import { buildLocalizeRoute } from '../../../../helpers/languageHelper';

export const UserLockOutDialog = ({ state, onClose = (e) => { } }) => {
	const { t } = useTranslation();
	return (
		<>
			<DialogWrapper
				maxWidth="sm"
				state={state}
				onClose={() => {
					onClose(false);
				}}
				title={t('accountTemporarilyLocked')}
				content={
					<Box className="!text-sm text-center">
						<TextWrapper
							type="span"
							classList="caption"
							text={t('accountTemporarilyLockedText')}></TextWrapper>
						<TextWrapper
							type="span"
							classList="caption"
							text={t('enterCorrectPassword')}></TextWrapper>
						<Box className='mt-2'>
							<a
								onClick={() => {
									onClose();
								}}
								className="!text-sm underline hover:no-underline"
								href={`${buildLocalizeRoute(AppRoutes.ForgotPassword)}`}>
								{t('resetMyPassowrd')}
							</a>
						</Box>
						<Box className="flex flex-row justify-center items-center mt-4">
							<FsButton
								type="button"
								onClick={() => {
									onClose();
								}}>{t('okGotIt')}</FsButton>
						</Box>
					</Box>
				}
			></DialogWrapper>
		</>
	);
};
